import Swal from 'sweetalert2';

const BRAND_RED = '#B91C1C';
const BRAND_GOLD = '#C9A227';

export function confirmPurchase({
  title = 'ยืนยันการซื้อ',
  html,
  text,
  confirmText = 'ยืนยันซื้อ',
  cancelText = 'ยกเลิก',
} = {}) {
  return Swal.fire({
    title,
    html,
    text,
    icon: 'question',
    showCancelButton: true,
    focusCancel: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: BRAND_RED,
    cancelButtonColor: '#6B7280',
  }).then((result) => result.isConfirmed);
}

export function showSuccess({ title = 'สำเร็จ', text, html } = {}) {
  return Swal.fire({
    title,
    text,
    html,
    icon: 'success',
    confirmButtonText: 'ตกลง',
    confirmButtonColor: BRAND_GOLD,
  });
}

export function showError({ title = 'เกิดข้อผิดพลาด', text, html } = {}) {
  return Swal.fire({
    title,
    text,
    html,
    icon: 'error',
    confirmButtonText: 'ตกลง',
    confirmButtonColor: BRAND_RED,
  });
}

export function getApiMessage(error, fallback = 'เกิดข้อผิดพลาด') {
  const message = error?.response?.data?.message;
  if (Array.isArray(message)) return message.join(', ');
  if (typeof message === 'string' && message.trim()) return message;
  return fallback;
}
